import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import { getUserType, getUserId } from "../../services/auth";
import api from '../../services/api';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import Header from '../../components/header';
import TitlePage from '../../components/title-page';
import Upload from '../../components/upload';
import LandingPageT1 from '../../components/themes/theme-1/body-lp';

const MAX_IMAGE_SIZE_MB = 1;

export default class CreateProject extends Component {
	state = {
		user_type: "",
		project_id: 0,
		projectTemplate_id: 0,
		company_list: [],
		company_list_opened: false,
		company_selected: 0,
		company_id: "",
		company_name: "",
		company_name_field: "",
		project_name: "",
		logo_src: "",
		logo_file_upload: "",
		banner_title: "",
		banner_text: "",
		banner_src: "",
		banner_file_upload: "",
		inputFileBanner: "",
		about_company: "",
		file_title: "",
		file_description: "",
		file_url: "",
		links: [],
		id_link_edit: 0,
		isEditing: false,
		accordion: [true, false, false, false],
		firstClickAccordion: true,
		modal_status: 'closed',
		modal_cancel: 'closed',
		project_type: "none",
		modal_project_type: 'opened',
		confidentiality: 'opened',
		fillName: false,
		fillLogo: false,
		fillFileTitle: false,
		fillFileDescription: false,
		fillFileUrl: false,
		check_save_default: "",
		cancel: false,
		error_message: ""
	}

	fileTitleInputRef = React.createRef();

	componentDidMount() {
		document.querySelector('body').classList.remove("no-scroll");

		const company_id = this.props.match.params.company_id;
		const project_id = this.props.match.params.project_id;
		const user_type = getUserType();
		const selectedCompany = localStorage.getItem("company_selected");

		if (parseInt(project_id) === 0) {
			if (user_type === "admin") {
				this.setState({ user_type: "admin" });
				this.loadApiCompany(selectedCompany);
			} else {
				this.setState({ user_type: "normal" });
				this.loadApiUser();
			}
		} else {
			this.setState({ company_id: company_id });
			this.loadApiProject(company_id, project_id);
		}
	}

	loadApiCompany = async (selectedCompany) => {
		try {
			const response = await api.get(`app_users?filter[include]=companies`);
			const list = [];
			response.data.forEach(company => {
				if (company.active) {
					company.companies.forEach(companie => list.push(companie));
				}
			});

			const selectedId = selectedCompany !== null ? parseInt(selectedCompany) : 0;
			const selected_item = selectedId !== 0
				? list.find(item => parseInt(item.id) === selectedId) || list[0]
				: list[0];

			this.setState({
				company_list: list,
				company_id: selected_item.id,
				company_name: selected_item.name,
				company_selected: selected_item.id
			});
		} catch (error) {
			this.setState({ error_message: 'Failed to load company list.' });
		}
	}

	loadApiUser = async () => {
		const userId = getUserId();
		try {
			const response = await api.get(`app_users/${userId}?filter[include]=companies`);
			this.setState({
				company_id: response.data.companies[0].id,
				company_name: response.data.companies[0].name
			});
		} catch (error) {
			this.setState({ error_message: 'Failed to load user data.' });
		}
	}

	loadApiProject = async (company_id, project_id) => {
		try {
			const response = await api.get(`companies/${company_id}/projects/${project_id}`);
			const response2 = await api.get(`companies/${company_id}/projects/${project_id}/banner`);
			const response3 = await api.get(`companies/${company_id}/projects/${project_id}/files`);

			this.setState({
				company_name_field: response.data.company_name,
				project_name: response.data.title,
				about_company: response.data.company_description,
				banner_title: response2.data.title,
				banner_text: response2.data.description,
				links: response3.data
			});
		} catch (error) {
			this.setState({ error_message: 'Failed to load project data.' });
		}
	}

	onChange = (e) => {
		this.setState({ [e.target.name]: e.target.value });
	}

	modal = (status) => {
		this.setState({ modal_status: status });
		if (status === "opened") {
			document.querySelector('body').classList.add("no-scroll");
		} else {
			document.querySelector('body').classList.remove("no-scroll");
		}
	}

	modalCancel = (status) => {
		if (status === "redirect") {
			document.querySelector('body').classList.remove("no-scroll");
			this.setState({ cancel: true });
		} else {
			this.setState({ modal_cancel: status });
			if (status === "opened") {
				document.querySelector('body').classList.add("no-scroll");
			} else {
				document.querySelector('body').classList.remove("no-scroll");
			}
		}
	}

	addLink = () => {
		this.setState({ fillFileTitle: false, fillFileDescription: false, fillFileUrl: false });

		const { file_title, file_description, file_url } = this.state;

		if (!file_title || !file_description || !file_url) {
			this.setState({
				fillFileTitle: !file_title,
				fillFileDescription: !file_description,
				fillFileUrl: !file_url
			});
			return;
		}

		const tempLinks = this.state.links;
		const id = tempLinks.length > 0 ? tempLinks[tempLinks.length - 1].id + 1 : 0;
		const url = file_url.includes('http') || file_url.includes('HTTP') ? file_url : "https://" + file_url;

		this.setState({
			file_title: "",
			file_description: "",
			file_url: "",
			links: [...tempLinks, { id, title: file_title, description: file_description, file_url: url }]
		}, () => {
			setTimeout(() => {
				const elAccordion = document.querySelector('.accordion-item.files');
				const height = parseFloat(getComputedStyle(elAccordion.querySelector('.accordion-content'), null).height.replace("px", "")) + 46;
				elAccordion.style.height = height + 'px';
			}, 100);
		});
	}

	selectEditLink = (id) => {
		const linkEdit = this.state.links.find(link => link.id === id);
		if (!linkEdit) return;

		const tempUrl = linkEdit.file_url.includes('http') || linkEdit.file_url.includes('HTTP')
			? linkEdit.file_url
			: "https://" + linkEdit.file_url;

		this.setState({
			isEditing: true,
			fillFileTitle: false,
			fillFileDescription: false,
			fillFileUrl: false,
			file_title: linkEdit.title,
			file_description: linkEdit.description,
			file_url: tempUrl,
			id_link_edit: id
		}, () => {
			if (this.fileTitleInputRef.current) {
				this.fileTitleInputRef.current.focus();
			}
		});
	}

	editLink = (id) => {
		const { file_title, file_description, file_url } = this.state;
		const tempUrl = file_url.includes('http') || file_url.includes('HTTP') ? file_url : "https://" + file_url;

		this.setState(prevState => ({
			isEditing: false,
			file_title: "",
			file_description: "",
			file_url: "",
			links: prevState.links.map(link =>
				link.id === id
					? { ...link, title: file_title, description: file_description, file_url: tempUrl }
					: link
			)
		}));
	}

	deleteLink = (id) => {
		this.setState(prevState => ({
			links: prevState.links.filter(link => link.id !== id)
		}), () => {
			setTimeout(() => {
				const elAccordion = document.querySelector('.accordion-item.files');
				const height = parseFloat(getComputedStyle(elAccordion.querySelector('.accordion-content'), null).height.replace("px", "")) + 46;
				elAccordion.style.height = height + 'px';
			}, 100);
		});
	}

	accordion = (e) => {
		const el = e.target.parentElement;
		const id = parseInt(el.id);
		const temp = [...this.state.accordion];

		if (temp[id] === true) {
			if (this.state.firstClickAccordion) {
				const height = parseFloat(getComputedStyle(el.querySelector('.accordion-content'), null).height.replace("px", "")) + 46;
				el.style.height = height + 'px';
				this.setState({ firstClickAccordion: false });
				setTimeout(() => { el.style.height = '45px'; }, 100);
			} else {
				el.style.height = '45px';
			}
			temp[id] = false;
		} else {
			const height = parseFloat(getComputedStyle(el.querySelector('.accordion-content'), null).height.replace("px", "")) + 46;
			el.style.height = height + 'px';
			temp[id] = true;
		}

		this.setState({ accordion: temp });
	}

	openCompanyList = () => {
		this.setState(prevState => ({ company_list_opened: !prevState.company_list_opened }));
	}

	changeCompany = (id) => {
		const company = this.state.company_list.find(c => c.id === id);
		if (!company) return;
		this.setState({ company_selected: id, company_id: id, company_name: company.name });
	}

	// extraPlugins requiere un constructor (class), no una arrow function.
	// El IIFE captura `this` del componente React para usarlo en el adapter.
	ckUploadAdapterPlugin = (() => {
		const component = this;
		return class CKUploadAdapterPlugin {
			constructor(editor) {
				editor.plugins.get('FileRepository').createUploadAdapter = (loader) => ({
					upload: async () => {
						const file = await loader.file;
						const form = new FormData();
						form.append('file', file);
						try {
							const res = await api.post(
								`companies/${component.state.company_id}/assets/upload`,
								form
							);
							return { default: res.data.url };
						} catch {
							return Promise.reject('Image upload failed. Please try again.');
						}
					},
					abort: () => {}
				});
			}
		};
	})();

	// Config estable: misma referencia en cada render → CKEditor no se reinicializa
	editorConfig = { extraPlugins: [this.ckUploadAdapterPlugin] };

	uploadLogo = (file, file_upload) => {
		this.setState({ logo_src: file, logo_file_upload: file_upload });
	}

	uploadBanner = (file, file_upload) => {
		this.setState({ banner_src: file, banner_file_upload: file_upload });
	}

	hendleSave = async () => {
		const { company_id, project_name, logo_src, logo_file_upload, company_name_field, about_company, check_save_default, project_type } = this.state;
		const is_template = check_save_default === "checked";

		this.setState({ fillName: false, fillLogo: false, error_message: "" });

		if (!company_id || !project_name || !logo_src) {
			this.setState({ fillName: !project_name, fillLogo: !logo_src });
			if (!project_name) {
				document.getElementById("project_name").focus();
			}
			scrollToTop(100);
			return;
		}

		if (logo_file_upload && logo_file_upload.size / (1024 * 1024) > MAX_IMAGE_SIZE_MB) {
			this.setState({ error_message: 'The logo image exceeds the maximum allowed size of 1 MB. Please choose a smaller image.' });
			return;
		}

		try {
			document.querySelector('.actions .btn-save').classList.add("load");
			const response = await api.post(`companies/${company_id}/projects`, {
				title: project_name,
				company_name: company_name_field,
				company_description: about_company,
				is_template: false,
				project_type: project_type
			});

			const project = response.data || null;
			if (!project || !project.id) {
				throw new Error('Unknown error when saving the project.');
			}

			await this.insertLogo(project.id);
			await this.insertBanner(project.id);
			await this.insertFiles(project.id);

			if (is_template) {
				const responseTemplate = await api.post(`companies/${company_id}/projects`, {
					title: project_name,
					company_name: company_name_field,
					company_description: about_company,
					is_template: true,
					project_type: project_type
				});
				const projectTemplate = responseTemplate.data || null;
				if (!projectTemplate || !projectTemplate.id) {
					throw new Error('Unknown error when saving the project template.');
				}

				await this.insertLogo(projectTemplate.id);
				await this.insertBanner(projectTemplate.id);
				await this.insertFiles(projectTemplate.id);
			}

			this.setState({ register_complete: true });
		} catch (error) {
			this.setState({ error_message: 'An error occurred while saving. Please try again.' });
			document.querySelector('.actions .btn-save').classList.remove("load");
		}

		function scrollToTop(scrollDuration) {
			const scrollStep = -window.scrollY / (scrollDuration / 15);
			const scrollInterval = setInterval(() => {
				if (window.scrollY !== 0) {
					window.scrollBy(0, scrollStep);
				} else {
					clearInterval(scrollInterval);
				}
			}, 15);
		}
	}

	insertLogo = async (project_id) => {
		const { company_id, logo_file_upload } = this.state;
		const form = new FormData();
		form.append('file', logo_file_upload);
		return await api.put(`companies/${company_id}/projects/${project_id}/logo/upload`, form);
	}

	insertBanner = async (project_id) => {
		const { company_id, banner_title, banner_text, banner_file_upload } = this.state;
		await api.put(`companies/${company_id}/projects/${project_id}/banner_data`, {
			title: banner_title,
			description: banner_text
		});
		if (banner_file_upload) {
			return await this.insertBannerImage(project_id);
		}
	}

	insertBannerImage = async (project_id) => {
		const { company_id, banner_file_upload } = this.state;
		const form = new FormData();
		form.append('file', banner_file_upload);
		return await api.put(`companies/${company_id}/projects/${project_id}/banner/upload`, form);
	}

	insertFiles = (project_id) => {
		const { company_id, links } = this.state;
		const linksPromises = links.map(link => {
			const url = link.file_url.includes('http') || link.file_url.includes('HTTP') ? link.file_url : "https://" + link.file_url;
			return api.post(`companies/${company_id}/projects/${project_id}/files`, {
				title: link.title,
				file_url: url,
				description: link.description
			});
		});
		return Promise.all(linksPromises);
	}

	saveAsDefault = () => {
		this.setState(prevState => ({
			check_save_default: prevState.check_save_default === "checked" ? "" : "checked"
		}));
	}

	modalProjectType = (status) => {
		this.setState({ modal_project_type: status });
	}

	projectTypeSelect = (type) => {
		this.setState({ project_type: type, modal_project_type: "closed" });
	}

	render() {
		if (this.state.cancel) return <Redirect to='/projects' />;
		if (this.state.register_complete) return <Redirect to='/projects' />;

		const { isEditing } = this.state;

		let logo;
		if (this.state.logo_src) {
			logo = <img src={this.state.logo_src} alt={this.state.company_name} />;
		} else {
			logo = <img src="https://via.placeholder.com/200x60?text=Logo" alt="logo" />;
		}

		let banner;
		if (this.state.banner_src) {
			banner = <img src={this.state.banner_src} alt={this.state.banner_title} />;
		}

		let companies;
		if (this.state.user_type === "admin") {
			companies = (
				<div data-component="company-selection" className={`company-list-container ${this.state.company_list_opened ? "active" : ""}`} onClick={() => this.openCompanyList()}>
					{this.state.company_name} :
					<div className="company-list">
						{this.state.company_list.map(company => (
							<button className={`company-item ${this.state.company_id === company.id ? "active" : ''}`} key={`collaborator-${company.id}`} onClick={() => this.changeCompany(company.id)}>
								{company.name}
							</button>
						))}
					</div>
				</div>
			);
		}

		return (
			<div data-page="create-project">
				<Header />

				<TitlePage title="Projects / New Projects" />

				<div className="container-fluid" data-component="create-project-content">
					<div className="container">
						<div className="actions-top">
							<Link to="/projects" className="btn blue-light">Back</Link>
						</div>

						{this.state.error_message && (
							<div className="error-message">
								<p className="text">{this.state.error_message}</p>
							</div>
						)}

						<div className="container-content">
							<div className="content">
								<div className="field-project-type">
									<button className="btn blue change-type" onClick={() => this.modalProjectType('opened')}>Change Project Type</button>
								</div>

								<div className="field-name-container">
									<p className="title">Project title</p>
									<div className={`field-name ${this.state.fillName ? "required" : ""}`}>
										{companies}
										<input
											autoComplete="off"
											id="project_name"
											name="project_name"
											type="text"
											placeholder="Insert a project name"
											value={this.state.project_name}
											onChange={e => this.onChange(e)}
										/>
									</div>
									{this.state.fillName && (
										<div className="required-field">
											<p className="text">Please give your project a name</p>
										</div>
									)}
								</div>

								<div className="accordion">
									<div className={`accordion-item ${this.state.accordion[0] ? 'opened' : ''}`} id="0">
										<button className="accordion-button" onClick={e => this.accordion(e)}>Insert Logo</button>
										<div className="accordion-content">
											<Upload title="" id="logoImage" size="500x100" imgPreview={this.state.logo_src || ""} handleClick={this.uploadLogo.bind(this)} />
											<div className="filed-infos">
												<div className="text-container">
													<b className="title">Recommended sizes:</b>
													<p className="text">
														Max height: 100px <br />
														Max width: 500px <br />
														Image cannot exceed 1 MB
													</p>
												</div>
											</div>
											{this.state.fillLogo && (
												<div className="required-field">
													<p className="text">Please insert a logo for this project</p>
												</div>
											)}
										</div>
									</div>

									<div className={`accordion-item ${this.state.accordion[1] ? 'opened' : ''}`} id="1">
										<button className="accordion-button" onClick={e => this.accordion(e)}>About the game</button>
										<div className="accordion-content">
											<div className="label">
												<p className="label-text">Title</p>
												<input
													autoComplete="off"
													name="banner_title"
													type="text"
													placeholder="Title"
													value={this.state.banner_title}
													onChange={e => this.onChange(e)}
												/>
											</div>
											<div className="label">
												<p className="label-text">Text</p>
												<CKEditor
													editor={ClassicEditor}
													config={this.editorConfig}
													data={this.state.banner_text}
													onChange={(event, editor) => {
														this.setState({ banner_text: editor.getData() });
													}}
												/>
											</div>
											<Upload title="Banner Image" id="bannerImage" size="1920x650" imgPreview={this.state.banner_src || ""} handleClick={this.uploadBanner.bind(this)} />
											<div className="filed-infos">
												<div className="text-container">
													<b className="title">Recommended sizes:</b>
													<p className="text">
														Width: 1920px <br />
														Height: 650px <br />
														Image cannot exceed 1 MB
													</p>
												</div>
											</div>
										</div>
									</div>

									<div className={`accordion-item ${this.state.accordion[2] ? 'opened' : ''}`} id="2">
										<button className="accordion-button" onClick={e => this.accordion(e)}>About company</button>
										<div className="accordion-content">
											<div className="label">
												<p className="label-text">Company name</p>
												<input
													autoComplete="off"
													name="company_name_field"
													type="text"
													placeholder="Title"
													value={this.state.company_name_field}
													onChange={e => this.onChange(e)}
												/>
											</div>
											<div className="label">
												<p className="label-text">About company</p>
												<CKEditor
													editor={ClassicEditor}
													config={this.editorConfig}
													data={this.state.about_company}
													onChange={(event, editor) => {
														this.setState({ about_company: editor.getData() });
													}}
												/>
											</div>
										</div>
									</div>

									<div className={`accordion-item files ${this.state.accordion[3] ? 'opened' : ''}`} id="3">
										<button className="accordion-button" onClick={e => this.accordion(e)}>Files</button>
										<div className="accordion-content">
											<p className="title-accordion-item">Insert file links</p>

											<div className={`label ${this.state.fillFileTitle ? "required-field" : ''}`}>
												<p className="label-text">Title</p>
												<input
													ref={this.fileTitleInputRef}
													autoComplete="off"
													name="file_title"
													type="text"
													placeholder="File name"
													value={this.state.file_title}
													onChange={e => this.onChange(e)}
												/>
											</div>
											<div className={`label ${this.state.fillFileDescription ? "required-field" : ''}`}>
												<p className="label-text">Description</p>
												<input
													autoComplete="off"
													name="file_description"
													type="text"
													placeholder="Short description"
													value={this.state.file_description}
													onChange={e => this.onChange(e)}
												/>
											</div>
											<div className={`label ${this.state.fillFileUrl ? "required-field" : ''}`}>
												<p className="label-text">URL</p>
												<input
													autoComplete="off"
													name="file_url"
													type="text"
													placeholder="url"
													value={this.state.file_url}
													onChange={e => this.onChange(e)}
												/>
											</div>

											<div className="label label-button">
												<button className={`btn blue-light ${isEditing ? 'inactive' : ''}`} onClick={() => this.addLink()}>Add</button>
												<button className={`btn blue-light ${isEditing ? '' : 'inactive'}`} onClick={() => this.editLink(this.state.id_link_edit)}>Edit</button>
											</div>

											{this.state.links.length > 0 && (
												<div className="list-links">
													<div className="link-header">
														<div className="col flex align-center sm-12 md-3 lg-3">
															<p className="title">Title</p>
														</div>
														<div className="col flex align-center sm-12 md-5 lg-5">
															<p className="title">Description</p>
														</div>
														<div className="col flex align-center sm-12 md-4 lg-4 table-actions">
															<p className="title">Actions</p>
														</div>
													</div>
													{this.state.links.map(link => (
														<div className="link-container" key={`collaborator-${link.id}`}>
															<div className="col flex align-center sm-12 md-3 lg-3">
																<div className="link-col"><p className="text">{link.title}</p></div>
															</div>
															<div className="col flex align-center sm-12 md-5 lg-5">
																<div className="link-col"><p className="text">{link.description}</p></div>
															</div>
															<div className="col flex align-center sm-12 md-4 lg-4 table-actions">
																<div className="link-col">
																	<button className="btn grey" onClick={() => this.selectEditLink(link.id)}>EDIT</button>
																	<button className="btn grey" onClick={() => this.deleteLink(link.id)}>DELETE</button>
																</div>
															</div>
														</div>
													))}
												</div>
											)}
										</div>
									</div>
								</div>

								<div className="save-as-default">
									<button onClick={() => this.saveAsDefault()} className={`${this.state.check_save_default}`}>
										<p className="text"> Save project as default </p>
									</button>
									<div className="filed-infos">
										<div className="text-container">
											<b className="title">Obs:</b>
											<p className="text">By checking this field, you can set up this page as a template. The fields will be already be filled in with the information above to create new projects quicker and more efficiently.</p>
										</div>
									</div>
								</div>

								<div className="actions">
									<button onClick={() => this.modal('opened')} className="btn blue-light preview-button preview-button-mobile">Preview</button>
									<button onClick={() => this.modalCancel('opened')} className="btn dark-grey">Cancel</button>
									<button onClick={() => this.hendleSave()} className="btn blue-light btn-save">Save</button>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div data-component="modal" className={`modal-project-type ${this.state.modal_project_type}`}>
					<div className="content">
						<button onClick={() => this.modalProjectType('closed')} className="close-modal"></button>
						<p className="text">Select the type of project you are creating</p>
						<div className="content-buttons">
							<button onClick={() => this.projectTypeSelect("production")} className={`btn blue ${this.state.project_type === "production" ? "active" : ""}`}>In Production</button>
							<button onClick={() => this.projectTypeSelect("finished")} className={`btn blue ${this.state.project_type === "finished" ? "active" : ""}`}>Finished Game</button>
						</div>
					</div>
				</div>

				<div data-component="modal" className={`modal-cancel ${this.state.modal_cancel}`}>
					<div className="content">
						<p className="text">If you proceed without save you will lose the entire process!<br /><b>Are you sure you want to cancel?</b></p>
						<button onClick={() => this.modalCancel('closed')} className="btn grey">No</button>
						<button onClick={() => this.modalCancel('redirect')} className="btn blue-light">Yes</button>
					</div>
				</div>

				<div data-component="modal" className={`${this.state.modal_status}`}>
					<button onClick={() => this.modal('closed')} className="close-modal"></button>
					<LandingPageT1
						logo={logo}
						banner={banner}
						bannerTitle={this.state.banner_title}
						bannerText={this.state.banner_text}
						companyName={this.state.company_name}
						aboutCompany={this.state.about_company}
						links={this.state.links}
					/>
				</div>
			</div>
		);
	}
}
